define([], function() {
    'use strict';

    function isNumber(value) {
        return typeof value === 'number';
    }

    return isNumber;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/is-number.js
 ** module id = 13
 ** module chunks = 0
 **/